import { FunctionComponent } from "react";

import { useTheme } from "@bps/fluent-ui";
import { FilterBar } from "@components/filter-bar/FilterBar";
import { Item } from "@components/filter-bar/FilterBar.types";
import { BpIdUsersSearchArgs } from "@libs/api/gateways/bp-id/bp-id.dtos";

interface BusinessUsersFilterProps {
  onFilter: (values: BpIdUsersSearchArgs) => void;
  onReset: () => void;
}

export const BusinessUsersFilter: FunctionComponent<BusinessUsersFilterProps> = ({
  onFilter,
  onReset
}) => {
  const theme = useTheme();

  const searchItems: Item<BpIdUsersSearchArgs>[] = [
    {
      type: "searchBox",
      name: "text",
      props: {
        placeholder: "Search object ID, username (email), or account name",
        removeSpecialCharacters: false,
        styles: { root: { width: 300 } }
      },
      stickItem: true
    }
  ];

  return (
    <>
      Find user accounts in the B2C database
      <FilterBar<BpIdUsersSearchArgs>
        items={searchItems}
        applyWithButton
        applyOnEnter
        onFilter={(_actions, values) => onFilter(values)}
        onReset={actions => {
          actions.reset();
          onReset();
        }}
        maxItemWidth={190}
        styles={{
          actions: {
            ".ms-TooltipHost:last-child .ms-Button--icon:not(:disabled)": {
              background: theme.palette.neutralLight,
              i: {
                color: theme.palette.themePrimary,
                fontWeight: 600
              }
            }
          }
        }}
      />
    </>
  );
};
